export const name = 'rnLocaleOrderBy';

export default function rnLocaleOrderBy(rnFormat) {
  'ngInject';

  return rnFormat.localeOrderBy;
}
